module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/242.2c055420.png";